import { notification } from 'antd';
import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import {
  postActivateGradingLimit, postCreateGradingLimit, postDeactivateGradingLimit, postUpdateGradingLimit,
} from './gradingLimitsApis';
import { GradingLimitsQueryKeys } from './gradingLimitsQueries';

export const useUpdateGradingLimit = (closeModal: () => void) => {
  const queryClient = useQueryClient();

  return useMutation('postUpdateGradingLimit', postUpdateGradingLimit, {
    onSuccess: () => {
      queryClient.invalidateQueries(GradingLimitsQueryKeys.GET_GRADE_LIST);
      notification.success({ description: 'The grade limit has been successfully updated.', message: 'Success!' });
      closeModal();
    },
    onError: (error: AxiosError<CapBayApiError>) => {
      queryClient.invalidateQueries(GradingLimitsQueryKeys.GET_GRADE_LIST);
      const errorMsg = error.response?.data.error.message;
      notification.error({ description: errorMsg, message: 'Failed to update' });
    },
  });
};

export const useDeactivateGradingLimit = (closeModal: () => void, selectedGrade: GradingLimits.GradingLimitsList) => {
  const queryClient = useQueryClient();

  return useMutation('postDeactivateGradingLimit', postDeactivateGradingLimit, {
    onSuccess: () => {
      queryClient.invalidateQueries(GradingLimitsQueryKeys.GET_GRADE_LIST);
      notification.success({ description: `Grade ${selectedGrade.grade} successfully deactivated`, message: 'Success!' });
      closeModal();
    },
    onError: () => {
      queryClient.invalidateQueries(GradingLimitsQueryKeys.GET_GRADE_LIST);
      notification.error({ description: 'An error has occured', message: 'Error' });
    },
  });
};

export const useActivateGradingLimit = (selectedGrade: GradingLimits.GradingLimitsList) => {
  const queryClient = useQueryClient();

  return useMutation('postActivateGradingLimit', postActivateGradingLimit, {
    onSuccess: () => {
      queryClient.invalidateQueries(GradingLimitsQueryKeys.GET_GRADE_LIST);
      notification.success({ description: `Grade ${selectedGrade.grade} successfully re-activated`, message: 'Success!' });
    },
    onError: () => {
      queryClient.invalidateQueries(GradingLimitsQueryKeys.GET_GRADE_LIST);
      notification.error({ description: 'An error has occured', message: 'Error' });
    },
  });
};

export const useCreateGradingLimit = (closeModal: () => void) => {
  const queryClient = useQueryClient();

  return useMutation('postUpdateGradingLimit', postCreateGradingLimit, {
    onSuccess: () => {
      queryClient.invalidateQueries(GradingLimitsQueryKeys.GET_GRADE_LIST);
      notification.success({ description: 'The grade has been successfully added.', message: 'Success!' });
      closeModal();
    },
    onError: (error: AxiosError<CapBayApiError>) => {
      queryClient.invalidateQueries(GradingLimitsQueryKeys.GET_GRADE_LIST);
      const errorMsg = error.response?.data.error.message;
      notification.error({ description: errorMsg, message: 'Failed to add.' });
    },
  });
};
